import { nullable, struct } from 'io-ts/lib/Decoder';

import { Id as ClientId } from '../../../../client';

export const Request = struct({
	clientId: nullable(ClientId),
});
